import { render } from "./Dropdown.vue?vue&type=template&id=2afa12df"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=2afa12df&lang=scss"
script.render = render

export default script